export const defaultFieldTeamReportTables = {
    "surveys_by_user": {
      "roles": ["superadmin", "client", "surveyworker", "qaworker", "partyworker"],
      "enabled": true
    },
    "surveys_by_date": {
      "roles": ["superadmin", "client", "surveyworker", "qaworker", "partyworker"],
      "enabled": true
    },
    "surveys_by_date_hour": {
      "roles": ["superadmin", "backoffice"],
      "enabled": true
    },
    "surveys_level1": {
      "roles": ["superadmin", "qaworker", "backoffice"],
      "enabled": true
    },
    "surveys_level2": {
      "roles": ["superadmin", "qaworker", "backoffice"],
      "enabled": true
    },
    "surveys_by_audio": {
      "roles": ["superadmin", "backoffice"],
      "enabled": true
    },
    "surveys_by_level1_audio": {
      "roles": ["superadmin"],
      "enabled": true
    },
    "surveys_by_level2_audio": {
      "roles": ["superadmin"],
      "enabled": true
    },
    "surveys_by_user_hl": {
      "roles": ["superadmin", "backoffice"],
      "enabled": true
    },
    "surveys_by_qa_check": {
      "roles": ["superadmin", "qaworker"],
      "enabled": true
    },
    "surveys_by_qa_check_only": {
      "roles": ["superadmin", "qaworker"],
      "enabled": true
    },
    "surveys_by_audio_only": {
      "roles": ["superadmin"],
      "enabled": true
    },
    "surveys_by_level1_hl": {
      "roles": ["superadmin"],
      "enabled": true
    },
    "surveys_by_level2_hl": {
      "roles": ["superadmin"],
      "enabled": true
    },
    "surveys_by_date_hl": {
      "roles": ["superadmin", "client"],
      "enabled": true
    },
    "field_summary": {
      "roles": ["superadmin", "partyworker", "backoffice"],
      "enabled": true
    }
  }
  

  export const mapTableNames = {
    "surveys_by_user": "Interviews by User",
    "surveys_by_date": "Interviews by Date",
    "surveys_by_date_hour": "Interviews by Hour",
    "surveys_level1": "Interviews by Level 1",
    "surveys_level2": "Interviews by Level 2",
    "surveys_by_audio": "Interviews by Audio",
    "surveys_by_level1_audio": "Interviews by Level 1 Audio",
    "surveys_by_level2_audio": "Interviews by Level 2 Audio",
    "surveys_by_user_hl": "Interviews by User Highlights",
    "surveys_by_qa_check": "Interviews by QA Check",
    "surveys_by_qa_check_only": "Interviews by QA Check Only",
    "surveys_by_audio_only": "Interviews by Audio Only",
    "surveys_by_level1_hl": "Interviews by Level 1 Highlights",
    "surveys_by_level2_hl": "Interviews by Level 2 Highlights",
    "surveys_by_date_hl": "Interviews by Date Highlights",
    "field_summary": "Field Summary",
}